module.exports = __webpack_public_path__ + "img/免許証.d7627226.png";